export default "__VITE_PUBLIC_ASSET__7915dfc8__"